module.exports = __webpack_public_path__ + "static/media/image_12.5475d03c.png";